import { useCallback } from 'preact/hooks'
import { CSSRule } from '@gsc/types'
import { useCustomMedia } from '../useCustomMedia'
import { serializeCssRule } from './serialize'

interface UseSerializeStyle {
  serializeStyle: (style: CSSRule) => string
}

export function useSerializeStyle(): UseSerializeStyle {
  const customMedia = useCustomMedia()
  return {
    serializeStyle: useCallback((s: CSSRule) => serializeCssRule(s, customMedia), [customMedia]),
  }
}
